import { PaisMercadoGlobalEnum } from '../types/enums/pais-mercado-global.enum';

export const phoneMasks: Record<PaisMercadoGlobalEnum, string> = {
  [PaisMercadoGlobalEnum.BRA]: '+55 (99) 99999-9999',
  [PaisMercadoGlobalEnum.EUA]: '+1 (999) 999-9999',
  [PaisMercadoGlobalEnum.CHL]: '+56 9 9999 9999',
  [PaisMercadoGlobalEnum.PRY]: '+595 (999) 999-999',
  [PaisMercadoGlobalEnum.PER]: '+51 999 999 999',
  [PaisMercadoGlobalEnum.COL]: '+57 999 9999999',
  [PaisMercadoGlobalEnum.MEX]: '+52 999 999 9999',
  [PaisMercadoGlobalEnum.CAN]: '+1 (999) 999-9999',
  [PaisMercadoGlobalEnum.JPN]: '+81 90-9999-9999',
  [PaisMercadoGlobalEnum.GBR]: '+44 9999 999999',
  [PaisMercadoGlobalEnum.DEU]: '+49 9999 9999999',
  [PaisMercadoGlobalEnum.FRA]: '+33 9 99 99 99 99',
  [PaisMercadoGlobalEnum.ESP]: '+34 999 999 999',
  [PaisMercadoGlobalEnum.ITA]: '+39 999 999 9999',
  [PaisMercadoGlobalEnum.NLD]: '+31 6 99999999',
  [PaisMercadoGlobalEnum.POL]: '+48 999 999 999',
  [PaisMercadoGlobalEnum.BEL]: '+32 499 99 99 99',
  [PaisMercadoGlobalEnum.SWE]: '+46 70-999 99 99',
  [PaisMercadoGlobalEnum.DNK]: '+45 99 99 99 99',
  [PaisMercadoGlobalEnum.NOR]: '+47 999 99 999',
  [PaisMercadoGlobalEnum.FIN]: '+358 99 9999999',
  [PaisMercadoGlobalEnum.AUT]: '+43 699 99999999',
  [PaisMercadoGlobalEnum.IRL]: '+353 89 999 9999',
  [PaisMercadoGlobalEnum.PRT]: '+351 91 999 9999',
  [PaisMercadoGlobalEnum.CHE]: '+41 79 999 99 99',
  [PaisMercadoGlobalEnum.LUX]: '+352 691 999 999',
  [PaisMercadoGlobalEnum.MCO]: '+377 6 99 99 99 99',
};
